<a
  class="post-card"
  [routerLink]="post() | slug">
  <div class="post-card__header">
    <div [avatar]="{ user: owner(), size: 'small', imgSize: '42px' }"></div>
    <div class="post-card__header__info">
      <p
        class="bold"
        sharryEllipsisTooltip="1">
        {{ owner() | userName }}
      </p>
      <button
        mat-icon-button
        (click)="onLike(); $event.preventDefault(); $event.stopImmediatePropagation(); $event.stopPropagation()">
        <sharry-icon
          registryName="bookmark-simple-stroked"
          svgClass="svg-icon"
          [ngClass]="{ active: bookmarked() }"
          [ssr]="true">
        </sharry-icon>
      </button>
    </div>
  </div>
  <div class="post-card__body">
    <span>
      <strong>{{ shortAddress() }}</strong>
    </span>
    <span> {{ createdAt() }} </span>
    <p
      class="post-card__body__title bold"
      sharryEllipsisTooltip="2">
      {{ title() }}
    </p>
  </div>
  <picture data-image-loading>
    <img
      [alt]="'image' + title()"
      [src]="coverPictureUrl()" />
  </picture>
  <div class="post-card__footer">
    @if (hasContentLikes()) {
      <button
        mat-icon-button
        class="sharry-xs post-card__footer--icon semibold">
        <sharry-icon
          name="bello"
          svgClass="svg-icon"
          type="custom"></sharry-icon>
      </button>
      <span>{{ contentLikes() }}</span>
    }
  </div>
</a>
